import axios from 'axios';

const API_KEY = 'AIzaSyD0LiXNfyzRGqeBLrC10bBY1WK2z4OPYRs';
const BASE_URL = 'https://translation.googleapis.com/language/translate/v2';

export const translateText = async (text, targetLanguage) => {
  try {
    const response = await axios.post(BASE_URL, {
      q: text,
      target: targetLanguage,
      format: 'text',
    }, {
      params: { key: API_KEY }
    });

    return response.data.data.translations[0].translatedText;
  } catch (error) {
    console.error('Translation API error:', error);
    throw error;
  }
};